import Box from '@/components/modules/Box'
import FlipBox from '@/components/modules/Box/Flip'
import Form from '@/components/modules/Form'
import HTML from '@/components/modules/HTML'
import Image from '@/components/modules/Files/Image'
import Modal from '@/components/modules/Modal'
import ModalController from '@/components/modules/ModalController'
import PDF from '@/components/modules/Files/PDF'
import Project from '@/components/modules/Project'
import Slide from '@/components/modules/Slide'
import Slider from '@/components/modules/Slider'
import SmoothSlider from '@/components/modules/SmoothSlider'
import Idle from '@/components/modules/Idle'
import Video from '@/components/modules/Files/Video'
import Audio from '@/components/modules/Files/Audio'
import OtherFile from '@/components/modules/Files/OtherFile'
import Font from '@/components/modules/Files/Font'
import File from '@/components/modules/Files'
import Iframe from '@/components/modules/Iframe'
import Folder from '@/components/modules/Folder'
import Assets from '@/components/modules/Assets'
import LocaleChanger from '@/components/modules/LocaleChanger'

const componentLookup = {
  [Box.name]: Box,
  [FlipBox.name]: FlipBox,
  [Form.name]: Form,
  [HTML.name]: HTML,
  [Image.name]: Image,
  [Modal.name]: Modal,
  [ModalController.name]: ModalController,
  [PDF.name]: PDF,
  [Project.name]: Project,
  [Slide.name]: Slide,
  [Slider.name]: Slider,
  [Video.name]: Video,
  [Audio.name]: Audio,
  [OtherFile.name]: OtherFile,
  [Font.name]: Font,
  [File.name]: File,
  [Iframe.name]: Iframe,
  [Idle.name]: Idle,
  [SmoothSlider.name]: SmoothSlider,
  [Assets.name]: Assets,
  [Folder.name]: Folder,
  [LocaleChanger.name]: LocaleChanger
}

export default componentLookup

export function defaultValues (type) {
  return Object.entries(type.props).reduce((obj, [key, value]) => {
    if (typeof value.default === 'function') {
      obj[key] = value.default()
    } else if (value.default !== undefined) {
      obj[key] = value.default
    }
    return obj
  }, {})
}
